'use client'
// The rack, heard.
//
// Renders nothing. When the sim says he is at the rack (npc.action RACK)
// and the rack entity carries the jam he is playing, this starts it
// through lib/audio/rack and mixes it by the camera's distance every
// frame, the same way the piano is heard. When he walks off, it stops.
//
// The jam rides the entity state as { id, seconds, events }, written by
// the sim when the sitting begins, so a visitor who arrives mid-sitting
// still hears the right one, and a reconnect finds it in the snapshot.
//
// The drum machine beside the rack (24 Oct, sim-server world/Drums.js)
// is heard through the same player: at it (npc.action DRUMS), the beat he
// painted rides that entity as state.beat, the same shape. One player, so
// walking from the one to the other swaps what it plays.

import { useEffect, useRef } from 'react'
import { useFrame } from '@react-three/fiber'
import useGameStore from '../../../stores/gameStore'
import { startRack, stopRack, setRackDistance, isRackPlaying } from '../../../lib/audio/rack'

export function RackAudio() {
  const npcStates = useGameStore((s) => s.npcStates)
  const entityStates = useGameStore((s) => s.entityStates)
  const posRef = useRef(null)

  const bird = npcStates?.find?.((n) => n.id === 'npc_victor') || npcStates?.[0]
  const atDrums = bird?.action === 'DRUMS'
  const rack = entityStates?.find?.((e) => e.id === (atDrums ? 'activity_drums' : 'activity_rack'))
  const atRack = bird?.action === 'RACK' || atDrums
  const jam = (atDrums ? rack?.state?.beat : rack?.state?.jam) || null
  const jamId = jam?.id || null

  useEffect(() => {
    if (atRack && jam?.events?.length) startRack(jam)
    else stopRack()
    return () => stopRack()
  }, [atRack, jamId]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    posRef.current = rack?.pos ? { x: rack.pos.x, z: rack.pos.z } : null
  }, [rack?.pos?.x, rack?.pos?.z]) // eslint-disable-line react-hooks/exhaustive-deps

  useFrame(({ camera }) => {
    if (!isRackPlaying() || !posRef.current) return
    const dx = camera.position.x - posRef.current.x
    const dz = camera.position.z - posRef.current.z
    setRackDistance(Math.sqrt(dx * dx + dz * dz))
  })

  return null
}

export default RackAudio
